import type { Audit, ScreeningSnapshot } from "@/services/api/guardiansv2/types";
import { TriggeringChecksPanel } from "../shared/TriggeringChecksPanel";

export interface AuditTriggeredBySectionProps {
  audit: Audit;
  onEditRule?: (catalogueKey: string, ruleId: string) => void;
}

function checksFromSnapshot(snapshot: ScreeningSnapshot | null | undefined) {
  return snapshot?.failed_checks ?? [];
}

/** Issue-first lead: screening checks that triggered the linked alert. */
export function AuditTriggeredBySection({ audit, onEditRule }: AuditTriggeredBySectionProps) {
  const snapshot = audit.screening_snapshot;
  const checks = checksFromSnapshot(snapshot);
  const reportChecks =
    audit.report?.triggered_by?.map((title, index) => ({
      rule_id: `report-${index}`,
      title,
      status: "failed" as const,
    })) ?? [];

  const resolved = checks.length > 0 ? checks : reportChecks;
  if (resolved.length === 0) return null;

  return (
    <section className="mb-6" data-testid="audit-triggered-by">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
        Triggered by
      </p>
      {snapshot?.catalogue_key ? (
        <p className="mb-3 text-xs text-slate-500">
          Alert screening · {snapshot.catalogue_key}
          {snapshot.alert_title ? ` · ${snapshot.alert_title}` : ""}
        </p>
      ) : null}
      <TriggeringChecksPanel
        checks={resolved}
        catalogueKey={snapshot?.catalogue_key}
        onEditRule={onEditRule}
      />
    </section>
  );
}
